import styled from 'styled-components';

export const PayslipFormContainer = styled.div`
  background-color: #ef6262;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 0 auto;
  margin-bottom: 10px;
`;

export const FormTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: white
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FormField = styled.div`
  margin-bottom: 15px;
`;

export const Label = styled.label`
  font-weight: bold;
  margin-bottom: 5px;
  padding-right: 5px;
  color: white;
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
`;

export const Button = styled.button`
  background-color: #ef6262;
  color: #fff;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  &:hover{
    color: black;
  }
`;


export const SelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Select = styled.select`
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin: 5px;
`;